import type { Story } from '../data'
import { storyRenderMode } from './render-mode'

/** The server catalog emits quality_* only after rights and source checks. */
export function isExperimentalPreviewCandidate(story: Story): boolean {
  return storyRenderMode(story) === 'voice_conversion'
    && story.developmentOnly === true
    && story.experimentalPreviewAvailable === true
    && (story.conversionStatus === 'experimental_unverified'
      || (story.conversionAvailable !== true && (story.conversionStatus === 'quality_unverified' || story.conversionStatus === 'quality_failed')))
}

export function experimentalPreviewWarning(story: Story): string {
  return story.conversionStatus === 'quality_failed'
    ? '개발용 실험 변환입니다. 기존 품질 검사에서 내용이 틀리거나 목소리가 어색한 구간이 확인됐어요. 결과를 직접 듣고 확인한 뒤 사용해 주세요.'
    : '개발용 실험 변환입니다. 내용 정확도와 목소리 품질을 아직 검증하지 않았어요. 결과를 직접 듣고 확인한 뒤 사용해 주세요.'
}
